const EventData = [
  {
    owner: "Shredmonton",
    date: "2025-07-19T12:00:00",
    type: "Contest",
    title: "Inline Summer Skate Series",
    description:
      "We are honoured to present to the skating world our 6th installment of the Shredmonton Inline Summer Skate Series proudly presented in Treaty 6 Territory at the Enoch Cree Nation Skatepark on July 19, 2025! A special thank you to the Enoch Cree Nation Youth and Community Programs for being advocates and partners in presenting this year’s event. Registration is now LIVE, just follow the link in our Profile or visit www.shredmonton.ca to secure your spot!",
    link: "https://shredmonton.ca",
    coordinates: "53.50312668765072, -113.75973668867167",
    address: "Highway 60, Whitemud Dr NW, Enoch Cree 135, AB T7X 3Y3, Canada",
    city: "Edmonton",
    province: "AB",
  },
  {
    owner: "Shredmonton",
    date: "2025-07-20T12:00:00",
    type: "Path Skate",
    title: "River Pathway Skate",
    description: "Rolling the River Pathway",
    link: "https://shredmonton.ca",
    address: "8281 95a St NW #8273, Edmonton, AB T6C 3Y4, Canada",
    coordinates: "53.52110549311919, -113.47615937293196",
    city: "Edmonton",
    province: "AB",
  },
  {
    owner: "Vancouver Bladers",
    date: "2025-08-22T12:00:00",
    type: "Path Skate",
    title: "Tourist Trap",
    description:
      "Skating Vancouvers famous Seawall. Stops at Sunset Beach for Hang and Mini events. Finishing with a skate around Stanley Park to end at Third Beach.",
    link: "https://www.instagram.com/p/DJFQh9_TFFF/",
    address: "1455 Quebec St, Vancouver, BC V6A 3Z7, Canada",
    coordinates: "49.273397779027015, -123.103828723436",
    city: "Vancouver",
    province: "BC",
  },
  {
    owner: "Vancouver Bladers",
    date: "2025-08-23T12:00:00",
    type: "Contest",
    title: "Fraser Heights Blade/Quad Jam",
    description:
      "Aggressive/Freestyle contest held at Fraser Heights Skatepark.Open Jam formate with judge and spectator voting. Prizes and Cash for multiple categories and winners. After party and Chill",
    link: "https://www.instagram.com/p/DJFQh9_TFFF/",
    address: "10588 160 St, Surrey, BC V4N 0A1, Canada",
    coordinates: "49.194593394104835, -122.7768101993852",
    city: "Vancouver",
    province: "BC",
  },
  {
    owner: "Vancouver Bladers",
    date: "2025-08-24T12:00:00",
    type: "Path Skate",
    title: "Skate and Bake Sunday",
    description:
      "Meet up and Skate Seymour Demonstration Forest on Vancouvers North Shore. 20km skate round trip Smooth Wide Path with hills up and down for fun and workout, with a mid stop at a cool spot.( skate is for intermediate or advanced skaters )",
    link: "https://www.instagram.com/p/DJFQh9_TFFF/",
    address: "4400 Lillooet Rd, North Vancouver, BC V7J 3V9, Canada",
    coordinates: "49.35026354917564, -123.01459037327882",
    city: "Vancouver",
    province: "BC",
  },
];

export default EventData;
